import { Injectable, EventEmitter } from '@angular/core';
import { SignalRService, SignalREventService, Model, Equipment, Minesite, User, Document, DataArray, GlobalService, ToastrService } from './../index';

@Injectable()
export class ModelService {
    public beginFilter: EventEmitter<boolean> = new EventEmitter<boolean>();
    public modelChange: EventEmitter<Model[]> = new EventEmitter<Model[]>();
    public showDetailsChange: EventEmitter<Model> = new EventEmitter<Model>();
    public modelMinesitesChange: EventEmitter<Minesite[]> = new EventEmitter<Minesite[]>();
    public modelEquipmentChange: EventEmitter<Equipment[]> = new EventEmitter<Equipment[]>();
    public modelUsersChange: EventEmitter<User[]> = new EventEmitter<User[]>();
    public modelDocumentsChange: EventEmitter<Document[]> = new EventEmitter<Document[]>();
    public filteredModelsChange: EventEmitter<Model[]> = new EventEmitter<Model[]>();
    public showAttributesChange: EventEmitter<boolean> = new EventEmitter<boolean>();
    public equipmentCountChange: EventEmitter<number> = new EventEmitter<number>();

    public manipulateModel: EventEmitter<Model> = new EventEmitter<Model>();

    public models: DataArray<Model> = new DataArray<Model>();
    private filteredModels: DataArray<Model> = new DataArray<Model>(1);

    private serial: string;
    private activeEquipment: boolean;
    private inActiveEquipment: boolean;
    private selectedModels: number[];
    private selectedPoweredBys: number[];
    private selectedClassifications: number[];
    private live: boolean;
    constructor(
        private _signalRService: SignalRService,
        private _signalREventService: SignalREventService,
        private _GlobalService: GlobalService,
        private _toastrService: ToastrService
    ) {
        this.registerOnServerEvents();
    }

    public getModels(): void {
        this._signalRService.invoke('GetModels');
    }

    public getModelsConstraint() {
        this._signalRService.invoke('GetModels');
    }
    public getModelsConstraintStaged() {
        this._signalRService.invoke('GetModelsStaged');
    }

    public showDetails(model: Model): void {
        this.showDetailsChange.emit(model);
    }

    public manipulate(model: Model): void {
        this.manipulateModel.emit(model);
    }

    public create(model: Model): void {
        this._signalRService.invoke('LockStagingTab', Number(localStorage.getItem('User_ID'))).then((result: any) => {
            if (result != null) {
                if (result.IsNew) {
                    this._toastrService.displayToastrMessage('success', 'Staging environment is locked successfully', 'Staging environment Status!');
                    this._GlobalService.TriggerLockEnvironment('1');
                    this._signalRService.invoke('CreateModel', model.Name, model.ClassificationId, Number(localStorage.getItem('User_ID')));
                } else if (result.IsLocked && result.LockedBy == Number(localStorage.getItem('User_ID'))) {
                    this._signalRService.invoke('CreateModel', model.Name, model.ClassificationId, Number(localStorage.getItem('User_ID')));
                } else if (result.IsLocked && result.LockedBy != Number(localStorage.getItem('User_ID'))) {
                    this._toastrService.displayToastrMessage('error', result.Note, 'Staging environment Status!');
                    this._GlobalService.TriggerLockEnvironment('1');
                }
            }
        });

    }

    public save(model: Model): void {
        this._signalRService.invoke('LockStagingTab', Number(localStorage.getItem('User_ID'))).then((result: any) => {
            if (result != null) {
                if (result.IsNew) {
                    this._toastrService.displayToastrMessage('success', 'Staging environment is locked successfully', 'Staging environment Status!');
                    this._GlobalService.TriggerLockEnvironment('1');
                    this._signalRService.invoke('SaveModel', model.Id, model.Name, model.ClassificationId, model.Active, Number(localStorage.getItem('User_ID')));
                } else if (result.IsLocked && result.LockedBy == Number(localStorage.getItem('User_ID'))) {
                    this._signalRService.invoke('SaveModel', model.Id, model.Name, model.ClassificationId, model.Active, Number(localStorage.getItem('User_ID')));
                } else if (result.IsLocked && result.LockedBy != Number(localStorage.getItem('User_ID'))) {
                    this._toastrService.displayToastrMessage('error', result.Note, 'Staging environment Status!');
                    this._GlobalService.TriggerLockEnvironment('1');
                }
            }
        });

    }

    public delete(model: Model): void {
        this._signalRService.invoke('LockStagingTab', Number(localStorage.getItem('User_ID'))).then((result: any) => {
            if (result != null) {
                if (result.IsNew) {
                    this._toastrService.displayToastrMessage('success', 'Staging environment is locked successfully', 'Staging environment Status!');
                    this._GlobalService.TriggerLockEnvironment('1');
                    this._signalRService.invoke('DeleteModel', model.Id, Number(localStorage.getItem('User_ID')));
                } else if (result.IsLocked && result.LockedBy == Number(localStorage.getItem('User_ID'))) {
                    this._signalRService.invoke('DeleteModel', model.Id, Number(localStorage.getItem('User_ID')));
                } else if (result.IsLocked && result.LockedBy != Number(localStorage.getItem('User_ID'))) {
                    this._toastrService.displayToastrMessage('error', result.Note, 'Staging environment Status!');
                    this._GlobalService.TriggerLockEnvironment('1');
                }
            }
        });

    }

    public getEquipmentForModel(modelId: number): void {
        this._signalRService.invoke('GetEquipmentForModel', modelId, this.live);
    }
    public GetEquipmentForModelStaged(modelId: number): void {
        this._signalRService.invoke('GetEquipmentForModelStaged', modelId);
    }

    public getMinesitesForModel(modelId: number): void {
        this._signalRService.invoke('GetMinesitesForModel', modelId);
    }
    public getMinesitesForModelStaged(modelId: number): void {
        this._signalRService.invoke('getMinesitesForModelStaged', modelId);
    }

    public getUsersForModel(modelId: number): void {
        this._signalRService.invoke('GetUsersForModel', modelId);
    }
    public getUsersForModelStaged(modelId: number): void {
        this._signalRService.invoke('getUsersForModelStaged', modelId);
    }

    public getDocumentsForModel(modelId: number): void {
        this._signalRService.invoke('GetDocumentsForModel', modelId);
    }

    public applyFilter(serial: string, activeEquipment: boolean, inActiveEquipment: boolean, live: boolean, selectedModels: number[], selectedPoweredBys: number[], selectedClassifications: number[]): void {
        this.serial = serial;
        this.activeEquipment = activeEquipment;
        this.inActiveEquipment = inActiveEquipment;
        this.selectedModels = selectedModels;
        this.selectedPoweredBys = selectedPoweredBys;
        this.selectedClassifications = selectedClassifications;
        this.live = live;
        this._signalRService.invoke('FilterModels', serial, activeEquipment, inActiveEquipment, live, selectedModels, selectedPoweredBys, selectedClassifications);
    }

    public getFilteredModels(): void {
        this._signalRService.invoke('FilterModels', this.serial, this.activeEquipment, this.inActiveEquipment, this.live, this.selectedModels, this.selectedPoweredBys, this.selectedClassifications);
    }

    public getEquipmentCount(modelId: number): Promise<number> {
        return this._signalRService.invoke('FilteredEquipmentCountForModel', modelId, this.serial, this.activeEquipment, this.inActiveEquipment, this.selectedPoweredBys, this.live).then((data: number) => {
            return data;
        });
    }
    public getEquipmentCountStaged(modelId: number): Promise<number> {
        return this._signalRService.invoke('FilteredEquipmentCountForModelStaged', modelId, this.serial, this.activeEquipment, this.inActiveEquipment, this.selectedPoweredBys).then((data: number) => {
            return data;
        });
    }

    public showAttributes(): void {
        this.showAttributesChange.emit(true);
    }

    private onModels(info: any): void {
        for (const item of info.Data.Models) {
            const model: Model = $.extend(new Model(), item);
            this.models.push(model);
        }
        this.modelChange.emit(this.models.Data);
    }

    private onModelEquipment(info: any): void {
        const equipment: Equipment[] = [];
        for (const equip of info.Data.Equipment) {
            equipment.push($.extend(new Equipment(), equip));
        }

        this.modelEquipmentChange.emit(equipment);
    }

    private onModelMinesites(info: any): void {
        const minesites: Minesite[] = [];
        for (const minesite of info.Data.Minesites) {
            minesites.push($.extend(new Minesite(), minesite));
        }

        this.modelMinesitesChange.emit(minesites);
    }

    private onModelUsers(info: any): void {
        const users: User[] = [];
        for (const user of info.Data.Users) {
            users.push($.extend(new User(), user));
        }

        this.modelUsersChange.emit(users);
    }

    private onModelDocuments(info: any): void {
        const documents: Document[] = [];
        for (const document of info.Data.Documents) {
            documents.push($.extend(new Document(), document));
        }

        this.modelDocumentsChange.emit(documents);
    }

    private onModelCreate(info: any): void {
        this.beginFilter.emit(true);
        const model: Model = $.extend(new Model(), info.Data.Model)
        this.models.unshift(model);
        this.filteredModelsChange.emit(this.models.Data);
        this.applyFilter('', true, true, false, [], [], []);
       // this._signalRService.invoke("Get_Models_Under_Project", Number(localStorage.getItem('P_ID')));
    }

    private onModelUpdate(info: any): void {
        this.applyFilter('', true, true, false, [], [], []);
        //this._signalRService.invoke("Get_Models_Under_Project", Number(localStorage.getItem('P_ID')));

        const model: Model = $.extend(new Model(), info.Data.Model)
        this.models.update(model);
        this.filteredModelsChange.emit(this.models.Data);

    }

    private onModelDelete(info: any): void {
        //let model: Model = $.extend(new Model(), info.Data.Model)
        //this.models.update(model);
        //this.filteredModelsChange.emit(this.models.Data);

        this.applyFilter('', true, true, false, [], [], []);

    }
    private onFilteredModels(info: any): void {
        for (const item of info.Data.Models) {
            const model: Model = $.extend(new Model(), item);
            this.filteredModels.push(model);
        }

        this.filteredModelsChange.emit(this.filteredModels.Data);
    }

    private onEquipmentCountChanged(info: any): void {
        const equipment: Equipment = $.extend(new Equipment(), info.Data.Equipment);
        this.equipmentCountChange.emit(equipment.ModelId);
    }

    private onEquipmentCountChangedDeleted(info: any): void {
        this.equipmentCountChange.emit(info.Data.ModelId);
    }

    private registerOnServerEvents() {
        this._signalREventService.register('ModelService', 'models', (info: any) => this.onModels(info));
        this._signalREventService.register('ModelService', 'beginRecieveModels', () => { this.models.init(); });
        this._signalREventService.register('ModelService', 'modelCreate', (info: any) => this.onModelCreate(info));
        this._signalREventService.register('ModelService', 'modelUpdate', (info: any) => this.onModelUpdate(info));
        this._signalREventService.register('ModelService', 'modelDelete', (info: any) => this.onModelDelete(info));
        this._signalREventService.register('ModelService', 'modelEquipment', (info: any) => this.onModelEquipment(info));
        this._signalREventService.register('ModelService', 'modelMinesites', (info: any) => this.onModelMinesites(info));
        this._signalREventService.register('ModelService', 'modelUsers', (info: any) => this.onModelUsers(info));
        this._signalREventService.register('ModelService', 'modelDocuments', (info: any) => this.onModelDocuments(info));
        this._signalREventService.register('ModelService', 'beginRecieveFilteredModels', () => { this.beginFilter.emit(true); this.filteredModels.init() });
        this._signalREventService.register('ModelService', 'filteredModels', (info: any) => this.onFilteredModels(info));
        this._signalREventService.register('ModelService', 'equipmentCreated', (info: any) => this.onEquipmentCountChanged(info));
        this._signalREventService.register('ModelService', 'equipmentDeleted', (info: any) => this.onEquipmentCountChangedDeleted(info));
    }

    public deregisterOnServerEvents(): void {
        this._signalREventService.deregister('ModelService');
    }
}
